import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import DependentProfileViewModel from '../DependentProfile/DependentProfileViewModel'
import EditPersonalProfileDialogViewModel from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import Button from 'components/Button'

interface Props {
  vm: DependentProfileViewModel
  editVM?: EditPersonalProfileDialogViewModel
  canEdit?: boolean
}

export default observer(function DependentsProfile({
  vm,
  editVM,
  canEdit,
}: Props) {
  if (!vm.dependentInfoSupportingItem) {
    return <></>
  }

  if (!vm.dependentProfiles?.length) {
    return <></>
  }

  const editable = Boolean(canEdit && editVM)

  return (
    <div>
      {vm.dependentProfiles.map((profile, index) => (
        <Section
          key={profile?.id}
          title={`${profile?.personalInfo?.fullName} (${profile?.relationship})`}
          loading={vm.activate.pending}
          actions={
            index === 0 && editable && editVM ? (
              <Button
                type="text"
                onClick={() => editVM.show('dependents')}
                data-test="update-dependents-information-button"
              >
                Edit
              </Button>
            ) : undefined
          }
        >
          <SectionItem
            label="Date of birth"
            value={profile?.personalInfo?.dateOfBirth}
            isSensitive
          />

          <SectionItem
            label="SSN or ITIN"
            value={profile?.personalInfo?.personalTaxpayerIdentificationNumber}
            maskedValue={
              profile?.personalInfo?.personalTaxpayerIdentificationNumberDisplay
            }
            isSensitive
          />
        </Section>
      ))}
    </div>
  )
})
